// 测试服务器
let urls = null;
let winOrigin = window.location.origin;
if (winOrigin.indexOf('crm.kedingdang.com') > -1) {
    urls = {
        wpcUrl: 'https://sclogin.kedingdang.com',
        crmUrl: 'https://crm.kedingdang.com',
        gmcUrl: 'https://gmc.kedingdang.com',
        smcUrl: 'https://smc.kedingdang.com',
        wpcApiUrl: 'https://scloginapi.kedingdang.com',
        crmApiUrl: 'https://crmapi.kedingdang.com',
        crmJavaApiUrl: 'https://micro-api-prod.kidcastle.com.cn/gw/jdb-school-crm',
        gmcApiUrl: 'https://gmcapi.kedingdang.com',
        smcApiUrl: 'https://smcapi.kedingdang.com',
    }
} else if (winOrigin.indexOf('chevady.cn') > -1) {
    urls = {
        wpcUrl: 'https://sclogin.chevady.cn',
        crmUrl: 'https://crm.chevady.cn',
        gmcUrl: 'https://gmc.chevady.cn',
        smcUrl: 'https://smc.chevady.cn',
        wpcApiUrl: 'https://scloginapi.kcclassin.com',
        crmApiUrl: 'https://crmapi.kcclassin.com',
        crmJavaApiUrl: 'https://micro-api-test.kidcastle.com.cn/gw/jdb-school-crm',
        gmcApiUrl: 'https://gmcapi.kcclassin.com',
        smcApiUrl: 'https://smcapi.kcclassin.com',
    }
} else if (winOrigin.indexOf('kcclassin.com') > -1) {
    urls = {
        wpcUrl: 'https://sclogin.kcclassin.com',
        crmUrl: 'https://crm.kcclassin.com',
        gmcUrl: 'https://gmc.kcclassin.com',
        smcUrl: 'https://smc.kcclassin.com',
        wpcApiUrl: 'https://scloginapi.kcclassin.com',
        crmApiUrl: 'https://crmapi.kcclassin.com',
        crmJavaApiUrl: 'https://micro-api-test.kidcastle.com.cn/gw/jdb-school-crm',
        gmcApiUrl: 'https://gmcapi.kcclassin.com',
        smcApiUrl: 'https://smcapi.kcclassin.com',
    }
} else {
    urls = {
        wpcUrl: 'https://sclogin.kcclassin.com',
        crmUrl: 'https://crm.kcclassin.com',
        gmcUrl: 'https://gmc.kcclassin.com',
        smcUrl: 'https://smc.kcclassin.com',
        wpcApiUrl: 'https://scloginapi.kcclassin.com',
        crmApiUrl: 'https://crmapi.kcclassin.com',
        crmJavaApiUrl: 'https://micro-api-test.kidcastle.com.cn/gw/jdb-school-crm',
        gmcApiUrl: 'https://gmcapi.kcclassin.com',
        smcApiUrl: 'https://smcapi.kcclassin.com',
    }
}

// 原先测试服务器
// const urls = {
//     wpcUrl: 'https://wpc.kidcastle.org',
//     crmUrl: 'https://crm.kidcastle.org',
//     gmcUrl: 'https://gmc.kidcastle.org',
//     smcUrl: 'https://smc.kidcastle.org',
//     //api接口域名
//     wpcApiUrl: 'https://wwwapi.kidcastle.org',
//     cmrApiUrl: 'https://crmapi.kidcastle.org',
//     gmcApiUrl: 'https://gmcapi.kidcastle.org',
//     smcApiUrl: 'https://smcapi.kidcastle.org'
// }

// urls = {
//     //网址域名
//     wpcUrl: 'https://sclogin.kedingdang.com',
//     crmUrl: 'https://crm.kedingdang.com',
//     gmcUrl: 'https://gmc.kedingdang.com',
//     smcUrl: 'https://smc.kedingdang.com',
//     //api接口域名
//     wpcApiUrl: 'https://scloginapi.kedingdang.com',
//     crmApiUrl: 'https://crmapi.kedingdang.com',
//     gmcApiUrl: 'https://gmcapi.kedingdang.com',
//     smcApiUrl: 'https://smcapi.kedingdang.com',
// }

export default urls;
